<template>
  <div class="h-screen bg-gray-100 flex flex-col">
    <header>
      <div class="inner-header">
        <div class="logo-container">
          <router-link to="/">
            <img src="@/assets/omind_logo.png" alt="" class="platform-logo" id="img_logo" />
          </router-link>
        </div>
        <h1 class="text-center xl:text-left leading-tight">
          OMIND Content Management Dashboard
        </h1>
        <span class="env-badge" :class="'env-badge--' + envInfo.color">
          {{ envInfo.label }}
        </span>
        <div class="header-times">
          <span class="header-time" title="Your local time">
            <i class="pi pi-clock"></i>
            Local: {{ localTime }}
          </span>
          <span class="header-time header-time-utc" title="UTC (server schedule reference)">
            UTC: {{ utcTime }}
          </span>
        </div>
      </div>
    </header>

    <div class="flex flex-1 overflow-hidden">
      <SideBar class="m-3" />
      <div class="m-3 bg-white rounded-lg shadow-lg w-full overflow-y-auto min-h-0">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/ContentManagement/common/SideBar.vue';
import { getEnvironmentInfo } from '@/helpers/environmentLabel';
// import { Toast } from 'primevue/toast';
// import { ConfirmDialog } from 'primevue/confirmdialog';

function formatTimeLocal(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${d} ${h}:${min}`;
}

function formatTimeUTC(date) {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  const h = String(date.getUTCHours()).padStart(2, '0');
  const min = String(date.getUTCMinutes()).padStart(2, '0');
  return `${y}-${m}-${d} ${h}:${min}`;
}

export default {
  name: 'DashboardLayout',
  components: {
    SideBar,
    // Toast,
    // ConfirmDialog,
  },
  data() {
    return {
      localTime: '',
      utcTime: '',
      timeInterval: null,
      envInfo: getEnvironmentInfo(),
    };
  },
  mounted() {
    const update = () => {
      const now = new Date();
      this.localTime = formatTimeLocal(now);
      this.utcTime = formatTimeUTC(now);
    };
    update();
    this.timeInterval = setInterval(update, 60000);
  },
  beforeUnmount() {
    if (this.timeInterval) clearInterval(this.timeInterval);
  },
};
</script>
<style scoped>
header {
  width: 100%;
  top: 0;
  padding: 0.7rem;
  z-index: 10;
}
.inner-header {
  display: flex !important;
  align-items: center;
  justify-content: start;
  margin-left: auto;
  margin-right: auto;
}
.logo-container {
  height: 100%;
  display: table;
  float: left;
}

.logo-container .platform-logo {
  width: 106px;
  height: auto;
  padding-top: 5px;
  display: table-cell;
  vertical-align: center;
}

.header-times {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  margin-left: auto;
  font-size: 1.05rem;
  color: #374151;
  line-height: 1.3;
}

.header-time {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.header-time i {
  font-size: 1.1rem;
  color: #6b7280;
}

.header-time-utc {
  color: #6b7280;
  font-weight: 500;
}

.env-badge {
  display: inline-block;
  padding: 0.2rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1.4;
  white-space: nowrap;
}

.env-badge--red {
  background: rgba(220, 38, 38, 0.15);
  color: #dc2626;
  border: 1px solid rgba(220, 38, 38, 0.4);
}

.env-badge--amber {
  background: rgba(217, 119, 6, 0.15);
  color: #d97706;
  border: 1px solid rgba(217, 119, 6, 0.4);
}

.env-badge--green {
  background: rgba(22, 163, 74, 0.15);
  color: #16a34a;
  border: 1px solid rgba(22, 163, 74, 0.4);
}
</style>
